export default import.meta.ROLLUP_FILE_URL_8Jdj9qQ4eJq3labUJOvRYQ;